import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as Ant from "antd";
import { useState } from "react";
import { useMutation } from "@apollo/client";
import { UploadTransactionCSV, } from "@bundles/UIAppBundle/queries/UploadTransactionCSV";
import { UploadOutlined } from "@ant-design/icons";
import { useTranslate } from "@bluelibs/x-ui";
export const CreateFromCSV = ({ bankAccountNumber, }) => {
    const t = useTranslate();
    const [status, setStatus] = useState(false);
    const [file, setFile] = useState();
    const [uploading, setUploading] = useState(false);
    const [mutateFunc] = useMutation(UploadTransactionCSV);
    const props = {
        onRemove: (file) => {
            setFile(undefined);
        },
        beforeUpload: (file) => {
            setFile(file);
            return false;
        },
        file,
    };
    const hanldeSend = async () => {
        if (file) {
            setUploading(true);
            mutateFunc({
                variables: {
                    upload: file,
                    input: { bankAccountNumber },
                },
            })
                .then((res) => {
                Ant.notification.success({
                    message: t("management.transactions.create_transactions_from_csv.success"),
                    description: `${t("management.transactions.create_transactions_from_csv.successfully_inserted")}: ${res.data.UploadTransactionCSV.length}`,
                });
                setStatus(false);
            })
                .catch((err) => {
                Ant.notification.warn({
                    message: t("management.transactions.create_transactions_from_csv.error"),
                    description: err.message,
                });
            })
                .finally(() => {
                setUploading(false);
            });
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Ant.Button, Object.assign({ onClick: () => setStatus(true) }, { children: t("management.transactions.create_transactions_from_csv.addTransactionsFromCSV") }), void 0), _jsxs(Ant.Modal, Object.assign({ open: status, onCancel: () => setStatus(false), footer: false }, { children: [_jsx(Ant.Typography, Object.assign({ className: "page-transactions-create-from-csv-text" }, { children: t("management.transactions.create_transactions_from_csv.uploadTransactionCSV") }), void 0), _jsx(Ant.Upload, Object.assign({ multiple: false }, props, { accept: "csv" }, { children: _jsx(Ant.Button, Object.assign({ icon: _jsx(UploadOutlined, {}, void 0) }, { children: t("management.transactions.create_transactions_from_csv.clicktoUploadCSV") }), void 0) }), void 0), _jsx(Ant.Button, Object.assign({ className: "page-transactions-create-from-csv-submit-btn", onClick: hanldeSend, loading: uploading }, { children: t("management.transactions.create_transactions_from_csv.Send") }), void 0)] }), void 0)] }, void 0));
};
